export default __webpack_public_path__ + "static/media/aircall_logo.bb035c2f.webp";